import React from 'react'

class CollapseButton extends React.Component {
  render() {
    const { id, onCollapse } = this.props
    return (
      <div className='collapse-button'>
        <a className='btn-text collapsed' data-toggle='collapse' role='button'
           href={`#${id}`}>
          <span>{this.props.openLabel}</span>
          <p onClick={onCollapse}>{this.props.closeLabel}</p>
        </a>
        <div className='clearfix' />
        <div className='collapse' id={id}>
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default CollapseButton;
